import request from '@/utils/request'
const BASE_URL = '/Log'

export default {
  list(data) {
    return request({
      url: BASE_URL + '/List',
      method: 'post',
      data
    })
  },
  info(id) {
    return request({
      url: BASE_URL + '/Info',
      method: 'get',
      params: { id }
    })
  },
  getIndexStat() {
    return request({
      url: BASE_URL + '/GetIndexStat',
      method: 'get',
    })
  }
}